// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsOptions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

myListsDetailsOptionsStyles.rightColumnWrapper = {
    css: css`
        display: flex;
        width: 40px;
        justify-content: center;
        margin-top: 20px;
        z-index: 10;
        ${xScreen("lte", "md")} {
            margin-top: 28px;
        }
    `,
}

myListsDetailsOptionsStyles.uploadItemsGridItem = {
    width: [12, 12, 12, 2, 2],
    css: css`
        align-items: flex-start;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    padding-top: 20px;
                `,
                css`
                    padding-top: 20px;
                `,
            ])}
    `,
}